import Mock from "../mock";

const database = {
  information: {
    name: 'Febrian Adhi Pratama',
    aboutContent: "I am a full-stack web app developer.",
    birthDate: new Date('1995-02-07'), // YYYY-MM-DD
    get age() {
      const today = new Date();
      const birthDate = this.birthDate;

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    phone: '',
    nationality: 'Indonesian',
    language: 'English, Indonesian',
    email: 'dev.brianpratama@gmail.com',
    address: 'Tarakan, North Kalimantan, Indonesia',
    freelanceStatus: 'Available',
    socialLinks: {
      facebook: '',
      twitter: '',
      pinterest: '',
      behance: '',
      linkedin: 'https://www.linkedin.com/in/brianpratama',
      dribbble: '',
      github: 'https://github.com/brian-pratama',
      gitlab: 'https://gitlab.com/brianpratama'
    },
    brandImage: '/images/brand-image.jpg',
    aboutImage: '/images/about-image.jpg',
    aboutImageLg: '/images/about-image-lg.jpg',
    cvfile: '/files/CV_2026-01-25_Febrian_Adhi Pratama.pdf'
  },
  services: [
    {
      title: "Web Development",
      icon: 'code',
      details: "I provide web development services using ReactJS, Vue, Fastify, and Golang. UI/UX design is not included."
    },
    {
      title: "Mobile Application",
      icon: 'mobile',
      details: "I provide mobile application development services using React Native."
    }
  ],
  reviews: [],
  skills: [
    {
      title: "HTML5",
      value: 100
    },
    {
      title: "Typescript",
      value: 100
    },
    {
      title: "Javascript",
      value: 100
    },
    {
      title: "ReactJS",
      value: 100
    },
    {
      title: "Vue",
      value: 75
    },
    {
      title: "Golang",
      value: 75
    },
    {
      title: "Fastify",
      value: 85
    }
  ],
  portfolios: [
    {
      id: 1,
      title: "E-Task 2.0",
      subtitle: "A web application to manage workflow in an office (CodeIgniter, MySQL)",
      imageUrl: "/images/portfolio-etask2-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-etask2-lg-1.jpg",
        "/images/portfolio-etask2-lg-2.jpg",
        "/images/portfolio-etask2-lg-3.jpg",
        "/images/portfolio-etask2-lg-4.jpg",
        "/images/portfolio-etask2-lg-5.jpg"
      ],
      url: ''
    },
    {
      id: 2,
      title: "Inagri Inventory Management",
      subtitle: "A web application to manage transactions in a warehouse (Vue.js, LoopBack3, MongoDB)",
      imageUrl: "/images/portfolio-Inventory-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-Inventory-lg-1.jpg",
        "/images/portfolio-Inventory-lg-2.jpg",
        "/images/portfolio-Inventory-lg-3.jpg",
        "/images/portfolio-Inventory-lg-4.jpg",
        "/images/portfolio-Inventory-lg-5.jpg",
        "/images/portfolio-Inventory-lg-6.jpg",
        "/images/portfolio-Inventory-lg-7.jpg",
        "/images/portfolio-Inventory-lg-8.jpg",
        "/images/portfolio-Inventory-lg-9.jpg",
        "/images/portfolio-Inventory-lg-10.jpg"
      ],
      url: ''
    },
    {
      id: 3,
      title: "Inagri Purchase",
      subtitle: "A B2B ecommerce app to manage sales (Vue.js, LoopBack3, MongoDB)",
      imageUrl: "/images/portfolio-inagri_purchase-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-inagri_purchase-lg-1.jpg",
        "/images/portfolio-inagri_purchase-lg-2.jpg",
        "/images/portfolio-inagri_purchase-lg-3.jpg",
        "/images/portfolio-inagri_purchase-lg-4.jpg",
        "/images/portfolio-inagri_purchase-lg-5.jpg",
        "/images/portfolio-inagri_purchase-lg-6.jpg",
        "/images/portfolio-inagri_purchase-lg-7.jpg",
      ],
      url: ''
    },
    {
      id: 4,
      title: "Sidiq HR",
      subtitle: "A mobile application to record employees' presency and meeting schedules (React Native, Flask, PostgreSQL)",
      imageUrl: "/images/portfolio-sidiqhr-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-sidiqhr-lg-1.jpg",
        "/images/portfolio-sidiqhr-lg-2.jpg",
        "/images/portfolio-sidiqhr-lg-3.jpg",
        "/images/portfolio-sidiqhr-lg-4.jpg",
        "/images/portfolio-sidiqhr-lg-5.jpg",
        "/images/portfolio-sidiqhr-lg-6.jpg",
        "/images/portfolio-sidiqhr-lg-7.jpg",
        "/images/portfolio-sidiqhr-lg-8.jpg",
        "/images/portfolio-sidiqhr-lg-9.jpg",
        "/images/portfolio-sidiqhr-lg-10.jpg",
        "/images/portfolio-sidiqhr-lg-11.jpg",
        "/images/portfolio-sidiqhr-lg-12.jpg",
        "/images/portfolio-sidiqhr-lg-13.jpg",
        "/images/portfolio-sidiqhr-lg-14.jpg",
        "/images/portfolio-sidiqhr-lg-15.jpg",
        "/images/portfolio-sidiqhr-lg-16.jpg",
        "/images/portfolio-sidiqhr-lg-17.jpg",
        "/images/portfolio-sidiqhr-lg-18.jpg",
        "/images/portfolio-sidiqhr-lg-19.jpg",
        "/images/portfolio-sidiqhr-lg-20.jpg",
        "/images/portfolio-sidiqhr-lg-21.jpg",
        "/images/portfolio-sidiqhr-lg-22.jpg",
        "/images/portfolio-sidiqhr-lg-23.jpg",
        "/images/portfolio-sidiqhr-lg-24.jpg",
        "/images/portfolio-sidiqhr-lg-25.jpg",
        "/images/portfolio-sidiqhr-lg-26.jpg",
        "/images/portfolio-sidiqhr-lg-27.jpg",
        "/images/portfolio-sidiqhr-lg-28.jpg",
      ],
      url: ''
    },
    {
      id: 5,
      title: "Inaventory",
      subtitle: "A web application to rent a warehouse (React.js, Flask, PostgreSQL)",
      imageUrl: "/images/portfolio-inaventory-lg.jpg",
      largeImageUrl: ["/images/portfolio-inaventory-lg.jpg"],
      url: ''
    },
    {
      id: 6,
      title: "Inaventory WMS",
      subtitle: "An application to manage warehouses (React.js, Flask, PostgreSQL)",
      imageUrl: "/images/portfolio-inaventory_wms-lg.jpg",
      largeImageUrl: ["/images/portfolio-inaventory_wms-lg.jpg"],
      url: ''
    },
    {
      id: 7,
      title: "World in Pro",
      subtitle: "A landing page for Inbound Technology (Next.js)",
      imageUrl: "/images/portfolio-wip-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-wip-lg-1.jpg",
        "/images/portfolio-wip-lg-2.jpg",
        "/images/portfolio-wip-lg-3.jpg",
        "/images/portfolio-wip-lg-4.jpg",
        "/images/portfolio-wip-lg-5.jpg",
        "/images/portfolio-wip-lg-6.jpg",
        "/images/portfolio-wip-lg-7.jpg",
        "/images/portfolio-wip-lg-8.jpg",
        "/images/portfolio-wip-lg-9.jpg",
        "/images/portfolio-wip-lg-10.jpg",
        "/images/portfolio-wip-lg-11.jpg"
      ],
      url: 'https://www.worldinpro.ib-tec.co.jp'
    },
    {
      id: 8,
      title: "World in Freelance",
      subtitle: "A recruitment website for freelancers to look for freelance jobs in Japan (Next.js, Fastify, DynamoDB)",
      imageUrl: "/images/portfolio-wif-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-wif-lg-1.jpg",
        "/images/portfolio-wif-lg-2.jpg",
        "/images/portfolio-wif-lg-3.jpg",
        "/images/portfolio-wif-lg-4.jpg",
        "/images/portfolio-wif-lg-5.jpg",
        "/images/portfolio-wif-lg-6.jpg",
        "/images/portfolio-wif-lg-7.jpg",
      ],
      url: 'https://worldinfreelance.ib-tec.co.jp'
    },
    {
      id: 9,
      title: "World in Hub",
      subtitle: "A recruitment website for jobseekers to look for jobs in Japan and for Japanese companies to post jobs (Next.js, Fastify, DynamoDB)",
      imageUrl: "/images/portfolio-wih-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-wih-lg-1.jpg",
        "/images/portfolio-wih-lg-2.jpg",
        "/images/portfolio-wih-lg-3.jpg",
        "/images/portfolio-wih-lg-4.jpg",
        "/images/portfolio-wih-lg-5.jpg",
        "/images/portfolio-wih-lg-6.jpg",
      ],
      url: 'https://www.worldinhub.ib-tec.co.jp'
    },
    {
      id: 10,
      title: "Recruit",
      subtitle: "A back office app to manage candidates, matching, client companies, jobs, and campaigns (Refine.dev, Fastify, DynamoDB)",
      imageUrl: "/images/portfolio-recruit-lg-1.jpg",
      largeImageUrl: [
        "/images/portfolio-recruit-lg-1.jpg",
        "/images/portfolio-recruit-lg-2.jpg",
        "/images/portfolio-recruit-lg-7.jpg",
        "/images/portfolio-recruit-lg-8.jpg",
        "/images/portfolio-recruit-lg-9.jpg",
        "/images/portfolio-recruit-lg-10.jpg",
      ],
      url: ''
    }
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "July 2023 - Present",
        position: "Director Assistant",
        company: "PT. Karina Utama, Tarakan, Indonesia",
        details: `PT. Karina Utama is a PSO LPG distribution company in Tarakan. My responsibilities include:
        • Prepared and managed company distribution reports, tax reports, and audit documentation for BPK RI.
        • Processed and maintained financial and administrative data to support internal review and external audits.
        • Attended key company meetings to present reports and support management decision-making.
        • Developed and used custom automation scripts to handle repetitive reporting and administrative tasks, 
        improving efficiency, reducing manual errors, and enabling lean staffing.`,
        techStacks: "NodeJS, WinForms, ReactJS, NeonDB"
      },
      {
        id: 2,
        year: "January 2022 - June 2023",
        position: "Web Developer",
        company: "CareerCraft.ai, Tarakan, Indonesia",
        details: `Made and maintained an HRD app.`,
        techStacks: "Strapi, AWS, PostgreSQL, and NeonDB"
      },
      {
        id: 3,
        year: "January 2022 - June 2023",
        position: "Software Engineer",
        company: "Inbound Technology Co. Ltd., Tokyo, Japan",
        details: `Building and maintaining IBT apps.
        • Recreated the front end of World In Pro (https://www.worldinpro.ib-tec.co.jp) and made it bilingual
        • Created the front end of World In Freelance (https://worldinfreelance.ib-tec.co.jp)
        • Created the front end of World In Hub (https://worldinhub.ib-tec.co.jp)
        • Creating unit tests and e2e tests for quality assurance
        • Working on the new back office app for IBT to manage candidates, client companies, jobs, matching, etc.`,
        techStacks: "Next.js, Refine.dev, React Testing Library, Fastify, DynamoDB, Jest, Cypress"
      },
      {
        id: 4,
        year: "January 2022 - December 2022",
        position: "Tech Recruiter",
        company: "Inbound Technology Co. Ltd., Tokyo, Japan",
        details: `Scouting candidates for Japanese companies`,
        techStacks: undefined
      },
      {
        id: 5,
        year: "August 2021 - December 2021",
        position: "Back-End Developer",
        company: "Ngorder, Malang, Indonesia",
        details: `Maintaining backend of app.ngorder.id and a little bit of the front-end, including:
        • Fixed product integration list.
        • Fixed bugs in Tokopedia features.
        • Made multi-shop features for shopee.
        • Fixed product integration list.`,
        techStacks: "PHP, Laravel, CodeIgniter, MariaDB, MySQL"
      },
      {
        id: 6,
        year: "March 2021 - July 2021",
        position: "Full-Stack Developer",
        company: "Inagri, Bandung, Indonesia",
        details: `• Maintained back-end for SIMAN, a software to manage assets. [Golang Echo]
        • Made back-end for BiBi landing page, a software by Telkom. [Strapi, PostgreSQL]
        • Maintained server and CI/CD for inagri.asia. [DigitalOcean, Nginx, Jenkins, Sonarqube]
        • Maintained server, made back-end and front-end for Blanja Import. [DigitalOcean, Nginx, Jenkins, Sonarqube, Strapi, PostgreSQL, React.js]
        • Made front-end and back-end for BlanjaImport Admin page. [DigitalOcean, Nginx, Strapi, Echo, PostgreSQL, React.js]`,
        techStacks: undefined
      },
      {
        id: 7,
        year: "December 2020 - January 2021",
        position: "Front-End Developer (Freelance)",
        company: "Inagri, Bandung, Indonesia",
        details: `Hired to make a B2B e-commerce application, Bibi Buyer. The client was Telkom.`,
        techStacks: "React.js"
      },
      {
        id: 8,
        year: "December 2019",
        position: "Front-End Developer (Freelance)",
        company: "Labtek Indie, Bandung, Indonesia",
        details: `Made Knods, a mobile webview application by Labtek Indie to organize projects for freelancers.`,
        techStacks: "React.js + Ionic"
      },
      {
        id: 9,
        year: "September 2018 - August 2019",
        position: "Full-Stack Developer",
        company: "Inagri, Bandung, Indonesia",
        details: `Mainly worked on front-end development and helped back-end devolopment and DevOps when needed. Made several apps, including:
        • Inagri Inventory Management Application [Vue.js, LoopBack, MongoDB]
        • Inagri Mobile Apps for Fresh B2C Ecommerce Application [React-Native]
        • PT. Ofal IT Outsource from Inagri for Sidiq HR Application - Bug Fixing [React-Native]
        • Full-stack engineer for www.inaventory.co.id [React.js, Flask]`,
        techStacks: undefined
      },
      {
        id: 10,
        year: "May 2017 - July 2017",
        position: "Full Stack Web Developer Intern",
        company: "Telkom Akses Slipi West Jakarta",
        details: `Made four web applications to help office work more efficiently.`,
        techStacks: 'CodeIgniter, PHP'
      },
      {
        id: 11,
        year: "May 2016 - July 2016",
        position: "Full Stack Web Developer Intern",
        company: "Telkom Akses Slipi West Jakarta",
        details: `Made E-Task, an application to monitor and manage every employees' works and has CRUD functionality with CodeIgniter.`,
        techStacks: 'CodeIgniter, PHP'
      }
    ],
    educationExperience: [
      {
        id: 1,
        year: "October 2014 - November 2020",
        graduation: "Bachelor of Engineering informatics",
        university: "Telkom University, Bandung, Indonesia",
        details: "My final project was 'Toxic Comments Identification Using BERT'. My research paper can be read here: https://openlibrary.telkomuniversity.ac.id/home/catalog/id/161820/slug/identifikasi-komentar-toksik-dengan-bert.html",
        paperUrl: "https://openlibrary.telkomuniversity.ac.id/home/catalog/id/161820/slug/identifikasi-komentar-toksik-dengan-bert.html"
      },
    ]
  },
  contactInfo: {
    phoneNumbers: ['+6282129297742'],
    emailAddress: ['dev.brianpratama@gmail.com'],
    address: "Jl. Sebengkok Waru, no.1, Tarakan, North Kalimantan, Indonesia"
  }
}


Mock.onGet("/api/information").reply(config => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply(config => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply(config => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply(config => {
  const response = database.experience;
  return [200, response];
});
